import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import BrightSpaceValenceApiWriterForm from '../forms/brightspace-valence-api-writer-form';
import { brightSpaceValenceApiWriterValidationSchema } from '../schema/brightSpaceValenceApiWriter.js';

export default function BrightSpaceValenceApiWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'BrightSpaceValenceApi Writer Node Details',
        altText: 'BrightSpaceValenceApi Writer Node',
        defaultLabel: 'BrightSpaceValenceApi Writer Node',
      }}
    >
      <CommonNode
        FormComponent={BrightSpaceValenceApiWriterForm}
        schemaResolver={brightSpaceValenceApiWriterValidationSchema}
      />
    </NodeProvider>
  );
}
